import { CardCvcElement, CardExpiryElement, CardNumberElement, Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useStripe, useElements } from '@stripe/react-stripe-js';
import axiosApi from '../../../core/interceptor/interceptor';
import { config, REGISTERED_THROUGH } from '../../../config';
import './Checkout.css';
import { userDetails } from '../../../store/reducer/LoggedInUserDetails';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import powered from '../../../assets/images/poweredBy-stripe.png';
import visa from '../../../assets/images/visa-img.png';
import moment from 'moment';
import { toast } from "react-toast";

const stripePromise = loadStripe(config.stripePublicKey);

const CheckoutForm = (props) => {
  const loggedInUserDetails = useSelector(userDetails);
  const stripe = useStripe();
  const elements = useElements();
  const history = useHistory();
  const [submitted, setSubmitted] = useState(false);
  const styles = {
    base: {
      color: '#000',
      fontWeight: 400,
      // fontFamily: 'Quicksand, Open Sans, Segoe UI, sans-serif',
      fontSize: '13px',
      fontSmoothing: 'antialiased',

      ':focus': {
        color: '#000',
      },

      '::placeholder': {
        color: '#44',
      },

      ':focus::placeholder': {
        color: '#1e1e1e',
      },
    },
    invalid: {
      color: '#f93737',
      ':focus': {
        color: '#f00',
      },
      '::placeholder': {
        color: '#ff6b6b',
      },
    },
  };


  const elementClasses = {
    focus: 'focus',
    empty: 'empty',
    invalid: 'invalid',
  };

  const [errors, setErrors] = useState({
    cardNumber: '',
    cardExpiry: '',
    cardCvc: ''
  });

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitted(true);
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardNumberElement),
      billing_details: {
        address: { city: loggedInUserDetails.city, line1: loggedInUserDetails?.address, postal_code: loggedInUserDetails?.zip },
        email: loggedInUserDetails?.email,
        name: loggedInUserDetails?.full_name,
        phone: loggedInUserDetails?.phone,
      }
    });

    if (!error) {
      axiosApi.post(`${config.apiUrl}/leagues/create-checkout-session/${props.leagueData.id}?type=${props.type ? props.type : 'team'}`, {
        paymentMethodId: paymentMethod.id, ...props.teamData, registered_through: REGISTERED_THROUGH, email: loggedInUserDetails?.email, current_date: moment().format('MM-DD-YYYY')
      }).then(async (response) => {
        if (response?.data?.status === 'requires_action' && response?.data?.data.client_secret) {
          props.closeModal();
          confirmAction(response?.data?.data.client_secret, paymentMethod.id);  
          setSubmitted(false);
        } else {
          history.push(props.type ? `/my-account` : `/my-account/teams/${response.data.data.id}`);
          props.closeModal();
          setSubmitted(false);
        }
      }).catch((err) => {
        if (err.response?.data?.status === 'error-registration-failed') {
          setErrors((prev) => ({
            ...prev,
            registrationErr: err.response?.data.message,
          }));

          setTimeout(() => {
            props.closeModal();
          }, 6000);
        } else if (err.response?.data?.status === 'error-email-failed') {
          history.push(`/my-account`);
          props.closeModal();
        }
        setSubmitted(true);
      });
    } else {
      if (error.message) {
        toast.error(error.message);
      }
      setSubmitted(false);
    }
  };

  // Call confirm payment method
  const confirmAction = async (client_secret, payment_method) => {
    await stripe.confirmCardPayment(client_secret, {
      payment_method,
    }).then((res) => {
      if (res.paymentIntent?.status === 'succeeded') {
        axiosApi.post(`${config.apiUrl}/leagues/create-checkout-session/${props.leagueData.id}?type=${props.type ? props.type : 'team'}`, {
          paymentMethodId: payment_method, ...props.teamData, registered_through: REGISTERED_THROUGH, email: loggedInUserDetails?.email, current_date: moment().format('MM-DD-YYYY'), paymentIntentId: res.paymentIntent.id, payment_completed: true
        }).then((res) => {
          history.push(props.type ? `/my-account` : `/my-account/teams/${res.data.data.id}`);
        })
      } else {
        let message = 'Payment Failed'
        if (res.error) {
          message = res?.error?.message ? res?.error?.message : 'Payment Failed';
        }
        toast.error(message);
      }
    }).catch((e) => {
      toast.error(e.message);
    });
  }

  const onChange = (ev) => {
    setErrors((prevState) => {
      return ({
        ...prevState,
        [ev.elementType]: ev && ev.error && ev.error.message ? ev.error.message : ''
      })
    });
  }

  const getAmount = () => {
    if (props.teamData && props.teamData.payment_type == 'card') {
      return 'Pay by Card';
    } else if (props.pay) {
      return 'Pay ' + props.pay
    } else {
      return 'Pay ' + ((+props.leagueData?.reg_fees + +props.leagueData?.for_feit_fees + 0.30) / (1 - 0.029)).toFixed(2);
    }
  }

  return (
    <div className="cell example example3" id="example-3">
      <div className="payment-heading">
        <h2>Payment</h2>
      </div>
      <div className="close-icon" onClick={() => props.closeModal && props.closeModal()}><div className="close"></div></div>
      <form>
        <div className="fieldset">
          <input id="example3-name" data-tid="elements_examples.form.name_label" className="field" type="text" name='full_name' value={loggedInUserDetails?.full_name} readOnly={true} autoComplete="name" />
          <input id="example3-email" data-tid="elements_examples.form.email_label" className="field half-width" name='full_name' value={loggedInUserDetails?.email} readOnly={true} />
          <input id="example3-phone" data-tid="elements_examples.form.phone_label" className="field half-width" type="tel" value={loggedInUserDetails?.cell_phone} readOnly={true} />
        </div>
        <div className="fieldset">

          <CardNumberElement className="field empty" options={{
            style: styles,
            classes: elementClasses
          }} onChange={(e) => onChange(e)} />
          <CardExpiryElement className="field empty third-width" options={{
            style: styles,
            classes: elementClasses
          }} onChange={(e) => onChange(e)} />
          <CardCvcElement className="field empty third-width" options={{
            style: styles,
            classes: elementClasses
          }} onChange={(e) => onChange(e)} />
          <input id="example3-zip" data-tid="elements_examples.form.postal_code_placeholder" className="field empty third-width" name='zip' value={loggedInUserDetails?.zip} readOnly={true} />
        </div>

        <button onClick={(e) => !submitted && handleSubmit(e)} type="button" data-tid="elements_examples.form.pay_button">{getAmount()}</button>
        {errors.cardNumber || errors.cardExpiry || errors.cardCvc || errors.registrationErr ?
          <div className="error" role="alert">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17">
              <path className="base" fill="#000" d="M8.5,17 C3.80557963,17 0,13.1944204 0,8.5 C0,3.80557963 3.80557963,0 8.5,0 C13.1944204,0 17,3.80557963 17,8.5 C17,13.1944204 13.1944204,17 8.5,17 Z"></path>
              <path className="glyph" fill="#FFF" d="M8.5,7.29791847 L6.12604076,4.92395924 C5.79409512,4.59201359 5.25590488,4.59201359 4.92395924,4.92395924 C4.59201359,5.25590488 4.59201359,5.79409512 4.92395924,6.12604076 L7.29791847,8.5 L4.92395924,10.8739592 C4.59201359,11.2059049 4.59201359,11.7440951 4.92395924,12.0760408 C5.25590488,12.4079864 5.79409512,12.4079864 6.12604076,12.0760408 L8.5,9.70208153 L10.8739592,12.0760408 C11.2059049,12.4079864 11.7440951,12.4079864 12.0760408,12.0760408 C12.4079864,11.7440951 12.4079864,11.2059049 12.0760408,10.8739592 L9.70208153,8.5 L12.0760408,6.12604076 C12.4079864,5.79409512 12.4079864,5.25590488 12.0760408,4.92395924 C11.7440951,4.59201359 11.2059049,4.59201359 10.8739592,4.92395924 L8.5,7.29791847 L8.5,7.29791847 Z"></path>
            </svg>
            <span className="message">{errors.cardNumber || errors.cardExpiry || errors.cardCvc || errors.registrationErr}</span>
          </div>
          : ''}
        <div className="img-blk">
          <img className="powered-img" src={powered} alt="stripe" />
          <img className="visa-img" src={visa} alt="visa" />
        </div>
      </form>
    </div>
  );
};

export default function Checkout(props) {
  const propData = { ...props };
  if (propData.teamData) {
    propData.teamData['name'] = (propData.teamData?.name || '').trim();
    propData.teamData['custom_option'] = (propData.teamData?.custom_option || '').trim();
  }
  return (
    <div className="globalContent">
      <main>
        <section className="container-lg">
          <Elements stripe={stripePromise}>
            <CheckoutForm {...propData} closeModal={() => props.closeModal()} />
          </Elements>
        </section>
      </main>
    </div>
  );
};